import React from "react";
import UserDetailsProvider from "./userDetails";
import MediaProvider from "./mediaContext";
import LanguageContextProvider from "./languageContext";

export default function ContextProvider({ children }) {
	return (
		<LanguageContextProvider>
			<UserDetailsProvider>
				<MediaProvider>{children}</MediaProvider>
			</UserDetailsProvider>
		</LanguageContextProvider>
	);
}
